export enum DeviceTypeEnum {
    Trius = 1,
    Berco = 2,
    Remoto = 3,
    HL7 = 4,
    Bluetooth = 5,
}